export default __webpack_public_path__ + "static/media/cp_geo_gg.c4621f36.svg";